<script setup lang="ts">
import { provide } from 'vue'

import { pillGroupKey } from './types'

const model = defineModel<any>()

const props = defineProps<{
  /**
   * Determines if multiple pills can be selected. If `false`, when selecting an
   * inactive pill, the previously active pull will be automatically deselected.
   * In this mode it is not possible to deselect an already active pill. Use
   * this to emulate radio-like behaviour.
   *
   * If set to `true`, pills can be selected and deselected without restriction.
   *
   * When `multiple` is set to true, the resuling `model` value will be an
   * array; otherwise a simple type.
   */
  multiple?: boolean
}>()

function setValue(value: any) {
  if (props.multiple) {
    const current = Array.isArray(model.value) ? model.value : []
    if (current.includes(value)) {
      model.value = current.filter((v) => v !== value)
    } else {
      model.value = [...current, value]
    }
  } else {
    model.value = value
  }
}

function isSelected(value: any) {
  if (props.multiple) {
    return Array.isArray(model.value) && model.value.includes(value)
  }
  return model.value === value
}

provide(pillGroupKey, {
  model,
  setValue,
  isSelected,
  multiple: props.multiple,
})
</script>

<template>
  <div class="glp-pill-list">
    <slot></slot>
  </div>
</template>

<style>
.glp-pill-list {
  display: inline-flex;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
  overflow: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
}
.glp-pill-list > .glp-pill {
  scroll-snap-align: center;
}
</style>
